import { AppState } from 'src/app/store'
import { BigOrder, ExportDepositValidator } from 'src/core/models'

export const getOrderListSelector = (state: AppState) => state.myOrders.myOrders
export const orderListSelector = (state: AppState) => state.myOrders.myOrders.list
export const filterOrderTextSelector = (state: AppState) => state.myOrders.myOrders.filterText
export const selectedOrdersSelector = (state: AppState) => state.myOrders.myOrders.selected
export const getOrderCertificatesSelector = (state: AppState) => state.myOrders.getCertificates
export const getOneOrderSelector = (state: AppState) => state.myOrders.getOne
export const getAllOrderItemsSelector = (state: AppState) => state.myOrders.getAllOrderItems

export const completedOrdersSelectors = (state: AppState) => {
  return state.myOrders.myOrders.list.map((o: BigOrder) => o.order.status === 'paid')
}

export const canExportOrdersSelector = (state: AppState): ExportDepositValidator => {
  const orders = state.myOrders.myOrders.selected
  if (orders.length === 0) return 'EMPTY_ERROR'
  else if (orders.find((d: BigOrder) => d.order.status !== 'paid')) return 'ONLY_PAID_ERROR'
  return 'SUCCESS'
}

export const ordersCertificatesSelector = (state: AppState): string[] => {
  const orders = state.myOrders.myOrders.selected
  let certificates  = []
  for (const order of orders) {
    for (const orderItem of order.order_items) {
      certificates.push(orderItem.certificatePath)
    }
  }
  return certificates
}

export const allOrdersCertificatesSelector = (state: AppState): string[] => {
  const orders = state.myOrders.myOrders.list
  let certificates  = []
  for (const order of orders) {
    for (const orderItem of order.order_items) {
      certificates.push(orderItem.certificatePath)
    }
  }
  return certificates
}
